/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * List of senior tiers for this game
 */
export type TierEnumDto = {
    value?: string;
    displayValue?: string;
    teamType?: TierEnumDto.teamType;
};
export namespace TierEnumDto {
    export enum teamType {
        SENIOR = 'SENIOR',
        YOUTH = 'YOUTH',
    }
}

